import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import CheckboxIcon from './checkbox-icon';
import InfoTooltip from './InfoTooltip';

const CheckboxWithTooltip = ({ id, name, checked, disabled, onChange, index, value, hasTooltip, tooltipConfig }) => (
  <div key={index} className="checkbox-wrapper">
    <label htmlFor={id}>
      <input type="checkbox" id={id} value={value} checked={checked} disabled={disabled} onChange={onChange} />
      <span className={cx({ disabled })} >{checked && <CheckboxIcon />}</span>
      <p className={cx('checkbox-title', { disabled })}>{name}</p>
      {hasTooltip && <InfoTooltip {...tooltipConfig} />}
    </label>
  </div>
);

CheckboxWithTooltip.propTypes = {
  id:            PropTypes.string,
  name:          PropTypes.string,
  checked:       PropTypes.bool,
  disabled:      PropTypes.bool,
  onChange:      PropTypes.func,
  index:         PropTypes.number,
  value:         PropTypes.string,
  hasTooltip:    PropTypes.bool,
  tooltipConfig: PropTypes.object
};

export default CheckboxWithTooltip;
